import { SimilarityFeature } from '@aloft/toolkit-shared';

export const FEATURE_LABELS: Record<SimilarityFeature, string> = {
  gla: 'GLA',
  proximityMiles: 'Proximity',
  actualAge: 'Actual Age',
  quality: 'Quality',
  condition: 'Condition',
  lotSize: 'Site Size',
  saleDate: 'Sale Date',
  bedroomCount: 'Bedrooms',
  fullBathCount: 'Full Baths',
  halfBathCount: 'Half Baths',
  garage: 'Garage',
  basement: 'Basement',
  pool: 'Pool',
};
